module.exports = __webpack_public_path__ + "media/src/images/step4-7d126981a131287b4b6eca27b7ca9b4a.png";